import {
    defineComponent
} from 'vue'

export default defineComponent ({
    name: 'CollaboratorsTable'
    , props: {
        fields: {
            type: Array
            , required: false
            , default: () => ([])
        }
        , items: {
            type: Array
            , required: false
            , default: () => ([])
        }
    }
    , methods: {
        management (data) {
            this.$emit('click:collaborator', data)
        }
    }
})